import Rest from '../Rest'

export default class PeopleService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/people'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
